/* The shop's notice board.
 *
 * Everybody signed in reads it and marks what they have read; the office is
 * what writes it. The server answers 403 to anyone else, so nothing here needs
 * to ask.
 *
 * Every call answers with the whole board and the unread count together, the
 * reads included — the count on the Dashboard tab has just changed, and one
 * round trip should say what it changed to rather than leaving the client to
 * ask again on shop wifi. */
import type {
  CreateNoticeRequest,
  NoticeBoardDto,
  NoticeDto,
  ReadNoticesRequest,
  UpdateNoticeRequest,
} from '@oneshot2pac/shared';
import { api } from './client';

export const noticesApi = {
  board: () => api.get<NoticeBoardDto>('/notices'),

  create: (body: CreateNoticeRequest) => api.post<NoticeDto>('/notices', body),

  /** Send only what changed. Correcting a notice does not make it new again. */
  update: (id: string, body: UpdateNoticeRequest) => api.patch<NoticeDto>(`/notices/${id}`, body),

  /** Take a notice down. It goes, and everyone's read of it goes with it. */
  remove: (id: string) => api.del<void>(`/notices/${id}`),

  /** Mark the notices actually drawn as seen — never "everything", because a
   *  notice put up while the dashboard sat open on a bench has not been read. */
  markRead: (body: ReadNoticesRequest) => api.post<NoticeBoardDto>('/notices/read', body),
};
